import { updateNavigationTopOffsetPropertyOnResize } from './navigation_top_offset';
window.up.compiler('.js-mobile_navigation', element => {
    return updateNavigationTopOffsetPropertyOnResize('mobile', element);
});
window.up.compiler('.js-desktop_navigation', element => {
    return updateNavigationTopOffsetPropertyOnResize('desktop', element);
});
const scrollToCurrentPageSelector = '.js-scroll_to_current_page';
window.up.compiler(scrollToCurrentPageSelector, element => {
    const currentPage = element.querySelector('[aria-current="page"]');
    if (currentPage) {
        const { x: currentPageX } = currentPage.getBoundingClientRect();
        const { width: pageWidth } = element.getBoundingClientRect();
        element.scrollTo(currentPageX + (currentPage.scrollWidth - pageWidth) / 2, element.scrollHeight);
    }
});
const opacifyScrollShadowSelector = '.js-opacify_scroll_shadow';
window.up.compiler(opacifyScrollShadowSelector, element => {
    const opacityWindowLength = 50;
    const parent = element.parentElement;
    if (parent) {
        const updateOpacity = () => {
            const { width: elementWidth } = element.getBoundingClientRect();
            const scrollRight = element.scrollWidth - elementWidth - element.scrollLeft;
            if (element.scrollLeft < opacityWindowLength) {
                const opacity = Math.max(0, element.scrollLeft / opacityWindowLength);
                parent.style.setProperty('--js-nav-bar-opacity-before', `${opacity}`);
            }
            else {
                parent.style.removeProperty('--js-nav-bar-opacity-before');
            }
            if (scrollRight < opacityWindowLength) {
                const opacity = Math.max(0, scrollRight / opacityWindowLength);
                parent.style.setProperty('--js-nav-bar-opacity-after', `${opacity}`);
            }
            else {
                parent.style.removeProperty('--js-nav-bar-opacity-after');
            }
        };
        updateOpacity();
        window.up.on(element, 'scroll', undefined, updateOpacity);
    }
});
